import Vue from 'vue';
import Vuex from 'vuex';
import { Commit } from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    rolesAction: {}
  },
  getters: {
    getRolesAction(state) {
      return state.rolesAction;
    }
  },
  mutations: {
    saveRolesAction(state, rolesAction: object) {
      state.rolesAction = rolesAction;
    }
  },
  actions: {
    saveRolesActionFun(context: { commit: Commit }, rolesAction: object) {
      context.commit('saveRolesAction', rolesAction);
    }
  },
  modules: {}
});
